import { getCloudinaryThemeFileUrl } from '@/integrations/cloudinary/helpers'

interface Props {
  fluid: boolean
  className?: string
}

const ContentDivider = ({ className }: Props) => {
  return (
    <>
      <div className={`divider ${className}`} />
      <style jsx>
        {`
          .divider {
            text-align: center;
            padding: 0;
            background-image: url(${getCloudinaryThemeFileUrl('images/elements/divider.png')});
            height: 85px;
            background-repeat: repeat-x;
            background-position: center;
            background-size: 1800px auto;
          }
        `}
      </style>
    </>
  )
}

export default ContentDivider
